import Icon, { IconName } from "components/ui/Icon";
import UILabel from "components/ui/UILabel";
import React from "react";
import styled from "styled-components";
import { formatCurrency } from "utils/string";
import { mediaMax } from "utils/theme";

const Wrapper = styled.div<{ $isActive?: boolean }>`
  display: flex;
  gap: 12px;
  padding: 16px;
  align-items: center;

  --background-color: ${(props) => props.theme.colors.uiBackground};
  --accent-color: ${(props) =>
    props.$isActive
      ? props.theme.colors.tertiary
      : props.theme.colors.disabled};
  background-color: var(--background-color);
  border: 1.5px solid
    color-mix(in srgb, var(--accent-color) 50%, var(--background-color));
  box-shadow: ${(props) => props.theme.shadows.regular};
  border-radius: ${(props) => props.theme.borderRadius.small}px;

  ${mediaMax("lg")} {
    padding: 12px;
    gap: 8px;
  }
`;

const IconWrapper = styled.div`
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 9999px;
  background: color-mix(
    in srgb,
    var(--accent-color) 20%,
    var(--background-color)
  );
`;

const Main = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Title = styled.div`
  display: flex;
  gap: 6px;
  height: 18px;
  align-items: center;
`;

const Tag = styled.div`
  display: flex;
  height: 18px;
  align-items: center;
  padding: 0 4px;

  border-radius: ${(props) => props.theme.borderRadius.micro}px;
  border: 1.5px solid
    color-mix(in srgb, var(--accent-color) 50%, var(--background-color));
  color: var(--accent-color);
`;

export interface TransactionItem {
  id: string;
  icon: IconName;
  title: string;
  amount: number;
  isAch?: boolean;
  isActive?: boolean;
}

const Transaction: React.FC<TransactionItem> = ({
  icon,
  title,
  amount,
  isAch,
  isActive,
}) => {
  return (
    <Wrapper $isActive={isActive}>
      <IconWrapper>
        <Icon name={icon} />
      </IconWrapper>
      <Main>
        <Title>
          <UILabel.Small>{title}</UILabel.Small>
          {isAch && (
            <Tag>
              <UILabel.Micro>ACH Debit</UILabel.Micro>
            </Tag>
          )}
        </Title>
        <UILabel.Medium>${formatCurrency(amount).split(".")[0]}</UILabel.Medium>
      </Main>
    </Wrapper>
  );
};

export default Transaction;
